import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const sortingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createSortingData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/sorting/create-selected`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['sortingRecord', 'sorting', 'sortingSummary', 'summaryProcessing','ripeningSortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Record")

            },

        }),
        createRejectedSortingData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/sorting/create-rejected`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['sortingRecord', 'sorting', 'sortingSummary','ripeningSortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Record")

            },

        }),
        getRooms: build.query({
            query: () => {
                return {
                    url: `/ripening-data/rooms`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['ripeningRooms'],
            async onQueryStarted(_, { queryFulfilled, }) {


                await handleQueryError(queryFulfilled)
            },
        }),
        searchSortingSelectedRecord: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/sorting/selected-logs?${paramData}`,
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['sortingRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getSortingHistory: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/sorting/history-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['sortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRipeningSortingSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/sorting/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningSortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updatePendingKg: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/sorting/update-pending-kg`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['sortingSummary','ripeningSortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Pending weight", "updated")
            },
        }),
    }),
});

export const {
    useGetRoomsQuery,
    useGetSortingHistoryQuery,
    useSearchSortingSelectedRecordQuery,
    useCreateRejectedSortingDataMutation,
    useCreateSortingDataMutation,
    useGetRipeningSortingSummaryQuery,
    useUpdatePendingKgMutation

} = sortingApi;